"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyArray = exports.arrayToObject = exports.arrayIncludes = void 0;
const emptyArray = [];
exports.emptyArray = emptyArray;
const arrayToObject = arr => [...arr].reduce((prev, next) => {
  const keyIsHyphenated = typeof next === 'string' && next.includes('-');
  return keyIsHyphenated ? Object.assign({}, prev, {
    [`'${next}'`]: next
  }) : Object.assign({}, prev, {
    [`${next}`]: next
  });
}, {});
exports.arrayToObject = arrayToObject;
const arrayIncludes = (arr, arg) => arr.includes(arg);
exports.arrayIncludes = arrayIncludes;